import React from 'react';

import Header from '@/core/components/Header';
import Modal from '@/core/components/Modal';
import UnblockProfileForm from '@/core/components/ProfileActions/UnblockProfileForm';
import ScrollDownItem from '@/core/components/ScrollDownItem';
import useDisclosure from '@/core/hooks/useDisclosure';
import type { UnblockAction } from '@/core/lib/new-architecture/domain/user.domain';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface UnblockActionComponentProps {
  action: UnblockAction;
  onSuccess: () => void;
}

const UnblockActionComponent: React.FC<UnblockActionComponentProps> = ({ action, onSuccess }) => {
  const { t } = useTranslationContext(['profile.actions']);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ScrollDownItem icon="block" content={t(action.text, { ns: 'profile.actions' })} type="button" onClick={onOpen} disabled={action.disabled} />
      <Modal type="popup" isOpen={isOpen} onClose={onClose}>
        <Header content="" iconAfter="close" onAfter={onClose} />
        <UnblockProfileForm
          uuid={action.uuid}
          onClose={() => {
            onClose();
            onSuccess();
          }}
          showToast
        />
      </Modal>
    </>
  );
};

export default UnblockActionComponent;
